/**
 * Created by Rodrigo Quesada on 03/05/17.
 */
import {Model, ModelMixin} from '../../../domain/model/common/model.class';
import {User} from '../../../domain/model/user/user.model';
import {Profile} from '../../../domain/model/profile/profile.model';
import ProjectionInformation = Model.ProjectionInformation;

export class ContactInfo extends ModelMixin() implements Model<ContactInfo> {

    TYPE = ContactInfo;
    static projectionInformation = new ProjectionInformation('contactInfo');

    user: User = new User();
    profile: Pick<Profile, 'contact' | 'address'> = new Profile();

    constructor(jsonData: any = {}) {
        super();
        this.user = new User(jsonData.user);
        this.profile = new Profile(jsonData.profile);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/model/contact-info.model.ts